// extracted by mini-css-extract-plugin
export default {"times_new_roman":"Style_times_new_roman__qyoMO","card":"Style_card__aeqI1"};